import SashiDo from 'lib/SashiDo';

import React, { Component } from 'react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import Icon from 'components/Icon/Icon.react';
import Button from 'components/Button/Button.react';
import Field from 'components/Field/Field.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import Label from 'components/Label/Label.react';
import TextInput from 'components/TextInput/TextInput.react';
import KeyField from 'components/KeyField/KeyField.react';
import Toggle from 'components/Toggle/Toggle.react';
import { jsonEqual } from 'lib/helpers';

import FlowView                from 'components/FlowView/FlowView.react';
import renderFlowFooterChanges from 'lib/renderFlowFooterChanges';

import settingsStyles from 'dashboard/Settings/Settings.scss';
import styles from '../CDN.scss'

export default class Settings extends Component {
  constructor(props) {
    super();

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.getInitialFields(this.props);
  }

  componentWillReceiveProps(NextProps) {
    this.getInitialFields(NextProps);
  }

  getInitialFields(props) {
    if(props.CDNServiceCurrentSiteData) {
      this.setState({
        loading: false,
        initialFields: props.CDNServiceCurrentSiteData,
      });
    }
  }

  renderForm({ fields, changes, setField, resetFields}) {
    const siteSettingsFields =
      <Fieldset legend="Site Details">
        <div className={settingsStyles.settingsBox}>
          <Field
            // label={<Label text="Site ID" tooltipText="Configures your site to use a different IP address for your origin server." />}
            // input={<KeyField name='site_id'>{fields.site_id}</KeyField> }
            label={<Label text="Site ID" tooltipText="Site ID => from API/cdn_site_get service_id<br />type: string" />}
            input={<KeyField name='service_id'>{fields.objectId}</KeyField> }
          />

          <Field
            // label={<Label text="CDN URL" />}
            // input={<TextInput value={fields.cdn_url} onChange={setField.bind(this, 'cdn_url')} /> }
            label={<Label text="Site URL" tooltipText="Site URL => from API/cdn_site_get site_url<br />type: string" />}
            input={<KeyField name='site_url'>{fields.domains[0]}</KeyField> }
          />

          <Field
            // label={<Label text="Origin URL" />}
            // input={<TextInput value={fields.origin_url} onChange={setField.bind(this, 'origin_url')} /> }
            // label={<Label text="Origin URL" tooltipText="Origin URL => ???<br />type: string" />}
            // жорката ще го смени от [] на стринг
            label={<Label text="Origin URL" tooltipText="Origin URL => from API/cdn_site_get origin_url<br />type: string" />}
            input={<TextInput value={fields.origins[0]} onChange={(result) => {
              setField('origins', [result]);
            }} /> }
          />

          <Field
            // label={<Label text="CDN URL" />}
            // input={<TextInput value={fields.cdn_url} onChange={setField.bind(this, 'cdn_url')} /> }
            label={<Label text="Origin Host Header" tooltipText="Origin Host Header => from API/cdn_site_get origin_host_header<br />type: string" />}
            input={<TextInput value={fields.origins_host_header} onChange={setField.bind(this, 'origins_host_header')} /> }
          />
        </div>
      </Fieldset>;


    // Custom Domain Settings
    // Add domain without protocol Ex. www.pivanov.com, cdn.pivanov.com etc.

    // Delete Site

    return (
      <div className={[settingsStyles.holder, 'ShowFooter'].join(' ')}>
        <PreLoader loading={this.state.loading}>
          {siteSettingsFields}
        </PreLoader>
      </div>
    );
  }

  render() {
    if(this.state.loading) {
      return <PreLoader loading={this.state.loading} />
    }

    return (
      <FlowView
        initialFields={this.state.initialFields}
        renderForm={this.renderForm.bind(this)}
        footerContents={({changes}) => renderFlowFooterChanges(changes, this.state.initialFields, userFieldOptions)}
        onSubmit={({changes, fields, setField}) => {
          return this.props.saveSettings(fields);
        }}
      />
    );
  }
}

const userFieldOptions = {
  cdn_url: {
    friendlyName: 'cdn url',
    // type: 'addition',
  },
  site_name: {
    friendlyName: 'site name',
    // type: 'addition',
  },
  origins: {
    friendlyName: 'Origin URL',
  },
  origins_host_header: {
    friendlyName: 'origin url',
    // type: 'addition',
  },
};

